<template>
  <v-card-title>
    <v-container class="pa-2">
      <v-card v-if="check_status_tranning" class="pl-2 pr-2 pt-2 pb-4">
          <v-row>
            <v-col style="text-align: center;" cols="12" md="12" >
              <h3>{{title_name}}</h3>
            </v-col>
          </v-row>
          <v-row
            class="mt-0"
            v-if="header_list.length > 0" 
            v-for="(item, index) in header_list" :key="index"
          >
            <v-col cols="12" md="12">
              <span>{{item.descriptions}}</span><br />
            </v-col>
          </v-row>
          
        <v-row class="pt-4">
          <v-col cols="12" md="6">
            <v-text-field
              ref="email"
              v-model="email"
              outlined
              dense
              label="E-mail"
              :disabled="email_disable"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-btn
                  depressed
                  width="100"
                  class="buttonblue"
                  @click="checkEmailFormat()"
                  :disabled="email_disable"
                >
                  Check
            </v-btn>
          </v-col>
        </v-row>  
        <v-row   v-if="check_otp">
          <v-col cols="12" md="2">
            <v-text-field
              ref="otp"
              v-model="otp"
              label="OTP"
              outlined
              dense
              :counter="6"
              @blur="checkNumber()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              depressed
              width="100"
              :style="{
                backgroundColor: '#254E58',
                color: 'white',
              }"
              @click="VerifyEmail()"
            >
                Verify
            </v-btn>
          </v-col>
        </v-row>
        <br />
        <card v-if="check_email">
          <v-row class="mt-0">
            <v-col cols="12" md="11"  class="d-flex justify-center">
              <v-card width="150">
                <v-img
                  :src="imageUrl"
                  max-height="150"
                  class="mt-3"
                  contain
                ></v-img>
              </v-card>
            </v-col>
            
            <v-col cols="12" md="12" class="d-flex justify-center">
              <input type="file" @change="onFileSelected"  style="font-size: 14px;"  accept="image/*"/>
            </v-col>
          </v-row>
          
          <br />
          <v-row class="mt-0">
            <v-col cols="12" md="3">
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="dataitem.prename_th"
                    @input="setPreOhter()"
                    :items="prename_th_list"
                    outlined
                    dense
                    label="คำนำหน้า"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="dataitem.pre_ohter_th"
                    outlined
                    dense
                    :disabled="check_prename_th"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="dataitem.first_name_th"
                outlined
                dense
                label="ชื่อ"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="dataitem.last_name_th"
                outlined
                dense
                label="นามสกุล"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" md="3">
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="dataitem.prename_en"
                    @input="setPreOhter()"
                    :items="prename_en_list"
                    outlined
                    dense
                    label="Title"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="dataitem.pre_ohter_en"
                    outlined
                    dense
                    :disabled="check_prename_en"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="dataitem.first_name_en"
                outlined
                dense
                label="Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="dataitem.last_name_en"
                outlined
                dense
                label="Lastname"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" md="3">
              <v-menu
                v-model="menu_date"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateRes"
                    label="วันเกิด"
                    append-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dataitem.birth_day"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="dataitem.age"
                outlined
                dense
                label="อายุ"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="dataitem.ethnicity"
                outlined
                dense
                label="เชื้อชาติ"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="dataitem.nationality"
                outlined
                dense
                label="สัญชาติ"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="dataitem.religion"
                outlined
                dense
                label="ศาสนา"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" md="3">
              <v-text-field
                ref="id_card_number"
                v-model="dataitem.id_card_number"
                outlined
                dense
                label="เลขบัตรประชาชน"
                :counter="13"
                @blur="checkIDCardNumber()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                ref="phone_number"
                v-model="dataitem.phone_number"
                outlined
                dense
                label="หมายเลขโทรศัพท์"
                :counter="10"
                @blur="checkPhoneNumber()"
              ></v-text-field>
            </v-col>
          </v-row>
        </card>
        <v-row 
          class="mt-0"
          v-if="footer_list.length > 0" 
          v-for="(item, index) in footer_list" :key="index"
        > 
          <v-col cols="12" md="12">
            <span>{{ item.descriptions }}</span><br />
          </v-col>
        </v-row>
        <v-row v-if="check_email">
          <v-col  style="text-align: center;" cols="12" md="12">
            <v-btn
              depressed
              width="200"
              class="mr-5 buttonblue"
              @click="saveItem()"
          
            >
              Register 
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card v-else>
        <v-row>
            <v-col style="text-align: center;" cols="12" md="12" >
              <h3>ยังไม่มีการเปิดอบรม </h3>
            </v-col>
        </v-row>
      </v-card>
    </v-container>
          <v-dialog v-model="dialogOldEmail" max-width="500px">
            <v-card>
            <v-card-title class="text-h5"
                >อีเมลนี้มีการสมัครสมาชิกอยู่เเล้ว คุณต้องการสมัคร การอบรม {{ title_name }} ด้วย สมาชิกเดิมหรือไหม</v-card-title
            >
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeOldEmail"
                >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="AddOldEmailConfirm"
                >OK</v-btn
                >
                <v-spacer></v-spacer>
            </v-card-actions>
            </v-card>
        </v-dialog>
      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />

      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />  
      
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";
const moment = require('moment-timezone');

export default {
  data() {
    return {
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      title_name: "",
      check_prename_th: true,
      check_prename_en: true,
      prename_th_list: ["นาย","นาง","นางสาว","อื่นๆ"],
      prename_en_list: ["Mr.","Mrs.","Miss.","Other"],
      menu_date: false,
      check_status_tranning: false,
      header_list: [],
      footer_list: [],
      email: "",
      check_email: false,
      otp: "",
      check_otp: false,
      dialogOldEmail: false,
      email_disable: false,
      dataitem: {
        prename_th: "",
        pre_ohter_th: "",
        first_name_th: "",
        last_name_th: "",
        prename_en: "",
        pre_ohter_en: "",
        first_name_en: "",
        last_name_en: "",
        birth_day: null,
        age: 0,
        ethnicity: "",
        nationality: "",
        religion: "",
        id_card_number: "",
        phone_number: "",
        image: ""
        
      },
      imageUrl: "https://upload.wikimedia.org/wikipedia/en/2/24/Crystal_personal.svg",
      data_tranning: {},
      email_id: 0,
      tu_user_id: 0,
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    computedDateRes() {
      return unity.formatDate(this.dataitem.birth_day);
    },
  },
  watch: {
  },
  async mounted() {
    this.$hideLoader();
    this.loadData();
    this.$hideLoader();
  },
  methods: {


    async loadData(){
      const res_data = await api.getTRANNING_HById(this.$route.params.tranning_id)
      console.log("res_data.data")
      console.log(res_data.data)
      if(res_data.data.length > 0){

        this.check_status_tranning = true;
        this.data_tranning = res_data.data[0];
        this.title_name = res_data.data[0].tranning_name;

        const res_h = await api.getTRANNING_DByIdType(this.$route.params.tranning_id,"Header")
        const res_f = await api.getTRANNING_DByIdType(this.$route.params.tranning_id,"Footer")


        this.header_list = res_h.data;
        console.log(res_f.data)
        this.footer_list = res_f.data;
      }
    },

    async checkEmail(){
      if (this.email == "") {
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check your email",
              "Please input valid email address",
              "text-h5 red--text text-center"
          );
          this.$refs["email"].focus();
          return;
      }
      this.$showLoader()
      const check_email_cond = await api.getDataEmailByEmailSQL(this.email)
      this.$hideLoader();
      console.log("check_email_cond.data")
      console.log(check_email_cond.data)

      let check_t = 0;
      if(check_email_cond.data.length >0){
        for (const [index, item] of check_email_cond.data.entries()){
          if(item.tranning_id == this.$route.params.tranning_id){
            check_t = 1;
          }

        }
        if(check_t == 1){
          this.email="";

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your email",
            "E-mail นี้เคยสมัคร Training นี้ไปเเล้ว",
            "text-h5 red--text text-center"
          );
          this.$refs["email"].focus();
          return;
        }
      }

      if(check_email_cond.data.length > 0 && check_email_cond.data[0].status == 2){
          this.tu_user_id = check_email_cond.data[0].tu_id;
          this.dialogOldEmail = true;
      } else{
        await this.checkEmailaction();
      }

    },
    async checkEmailaction(){

        let data = { email: "",}
        data.email = this.email;

        this.$showLoader()

        const res_check = await api.confirmemailRegister(data);

        if(res_check.status == 200){

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your email",
            `${res_check.data.message}`,
            "text-h5 green--text text-center"
          );
          this.$hideLoader();
          this.check_otp = true;
        }
    },

    async AddOldEmailConfirm(){
      this.dialogOldEmail = false;
      await this.checkEmailaction();
    },

    async closeOldEmail(){
      this.dialogOldEmail = false;
      this.email = "";

    },
    async checkEmailFormat() {
      if (this.email.trim() !== "") {
        // ใช้ Regex ที่ถูกต้องเพื่อตรวจสอบรูปแบบของอีเมล
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!emailPattern.test(this.email.trim())) {
          // รูปแบบของอีเมลไม่ถูกต้อง
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your email",
            "Invalid email format. Please enter a valid email.",
            "text-h5 red--text text-center"
          );
          this.$refs["email"].focus();
          return;
        }else{
          await this.checkEmail()
        }
      }
    },
    async checkNumber(){
      if(this.otp != ""){
        if (!/^[0-9]{0,6}$/.test(this.otp.trim())) {
          this.otp = "";
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check your email",
              "Invalid OTP. Please try again.",
              "text-h5 red--text text-center"
          );
          this.$refs["otp"].focus();
          return;
        }
      }
    },
    async checkIDCardNumber(){
      if(this.dataitem.id_card_number != ""){
        if (!/^[0-9]{0,13}$/.test(this.dataitem.id_card_number.trim())) {
          this.dataitem.id_card_number = "";
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Invalid Information",
              "Please Enter New ID Card Number Data",
              "text-h5 red--text text-center"
          );
          this.$refs["id_card_number"].focus();
          return;
        }
      }
    },
    async checkPhoneNumber(){
      if(this.dataitem.phone_number != ""){
        if (!/^[0-9]{0,10}$/.test(this.dataitem.phone_number.trim())) {
          this.dataitem.phone_number = "";
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check your email",
              "Please Enter New Phone Number Data",
              "text-h5 red--text text-center"
          );
          this.$refs["phone_number"].focus();
          return;
        }
      }
    },

    async VerifyEmail(){
      if (this.otp.trim() == "") {
          this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check your email",
              " Please enter OTP sent to your email.",
              "text-h5 red--text text-center"
          );
          this.$refs["otp"].focus();
          return;
      }
      let  data_ver = {
        email: "",
        otp_number: ""
      }
      data_ver.email = this.email.trim();
      data_ver.otp_number = this.otp.trim();

      // this.$showLoader();

      const res_ver = await api.verifyemailRegister(data_ver);

      console.log("res_ver.data")
      console.log(res_ver.data)
      if(res_ver.status == 200){
        this.email_id = res_ver.data.email_id;
        this.$hideLoader();
        if(res_ver.data.action_check){

          this.$showLoader();
          var data_user_o = {
            t_user_id: this.tu_user_id,
            tranning_id: this.$route.params.tranning_id,
          }

          const res_add_user_o =  await api.addTRANNING_USER_D(data_user_o);

          if(res_add_user_o.status == 200 || res_add_user_o.status == 201){
            this.$hideLoader();
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "Information Saved",
              "Information successfully saved",
              "text-h5 green--text text-center",
              `/login`
            );
          }else{
            this.$hideLoader()
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center"
            );
            return;
          }
        }else{
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Email Verified",
            "Verify Email successfully",
            "text-h5 green--text text-center",
          );
          this.check_otp = false
          this.email_disable = true;
          this.check_email = true;
        }
      }else if(res_ver.status == 204){
                this.$hideLoader();
                this.$store.state.global_push_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Informations Fail",
                    "Invalid OTP. Please try again.",
                    "text-h5 red--text text-center"
                );
                this.otp = ""
                this.$refs["otp"].focus();
                return;
      }else{
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async setPreOhter(){

      if(this.dataitem.prename_th == "อื่นๆ"){
        this.check_prename_th = false;
      }else{
        this.dataitem.pre_ohter_th = "";
        this.check_prename_th = true;
      }

      if(this.dataitem.prename_en == "Other"){
        this.check_prename_en = false;
      }else{
        this.dataitem.pre_ohter_en = "";
        this.check_prename_en = true;
      }

    },
    onFileSelected(event) {
      const file = event.target.files[0];
      this.dataitem.image = event.target.files[0];
      this.imageUrl = URL.createObjectURL(file);
    },
    async saveItem(){
      // console.log("this.dataitem:")
      // console.log(this.dataitem)

      let formData = new FormData();

      formData.append("emp_i_d", "");
      formData.append("user_role","");
      formData.append("username", this.email);
      formData.append("password", this.dataitem.id_card_number);
      formData.append("email", this.email);
      formData.append("phone", this.dataitem.phone_number);

      if(this.dataitem.prename_th == "อื่นๆ"){
        formData.append("prename_t_h", this.dataitem.pre_ohter_th);
      }else{
        formData.append("prename_t_h", this.dataitem.prename_th);
      }   

      formData.append("firstname", this.dataitem.first_name_th);
      formData.append("lastname", this.dataitem.last_name_th);

      if(this.dataitem.prename_en == "Other"){
        formData.append("prename_e_n", this.dataitem.pre_ohter_en);
      }else{
        formData.append("prename_e_n", this.dataitem.prename_en);
      }  

      formData.append("firstname_e_n", this.dataitem.first_name_en);
      formData.append("lastname_e_n", this.dataitem.last_name_en);

      let abb = "";
      abb = this.dataitem.first_name_en.split("")[0] + this.dataitem.last_name_en.split("")[0];
      formData.append("abbname_e_n", abb);

      //รอดึงค่า
      formData.append("company_i_d", this.data_tranning.company_id);
      formData.append("department_i_d", this.data_tranning.department_id);
      formData.append("position_i_d", this.data_tranning.position_id);
      formData.append("authorize_id", this.data_tranning.authorize_id);

      formData.append("emp_rate", 0);
      formData.append("emp_status", "A");
      console.log("this.dataitem.image")
      console.log(this.dataitem.image)
      formData.append("image", this.dataitem.image);
      formData.append("approver_level1", this.data_tranning.admin_id);
      formData.append("approver_level2", 0);
      formData.append("approver_level3", 0);
      formData.append("ip_authentication", "");
      formData.append("signature", "");
      formData.append("user_create", 0);
      formData.append("user_update", 0);

      this.$showLoader()
      const res_add = await api.addUserAccount(formData);
      console.log(res_add.data)

      if(res_add.status == 200 || res_add.status == 201){

     

        //create user
        let dataAdd_user = {
          user_id: 0,
          tranning_id: 0,
          te_id: 0,
          email: "",
          date: "",
          pre_name_th: "",
          first_name_th: "",
          last_name_th: "",
          pre_name_en: "",
          first_name_en: "",
          last_name_en: "",
          birth_day: "",
          age: 0,
          ethnicity: "",
          nationality: "",
          religion: "",
          id_card_number: "",
          phone_number: "",
        }

        dataAdd_user.user_id = res_add.data.id;
        dataAdd_user.te_id = this.email_id;
        dataAdd_user.email = this.email;
        dataAdd_user.date = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');

        if(this.dataitem.prename_th == "อื่นๆ"){
          dataAdd_user.pre_name_th = this.dataitem.pre_ohter_th;
        }else{
          dataAdd_user.pre_name_th = this.dataitem.prename_th;
        } 
        dataAdd_user.first_name_th = this.dataitem.first_name_th;
        dataAdd_user.last_name_th = this.dataitem.last_name_th;

        if(this.dataitem.prename_en == "Other"){
          dataAdd_user.pre_name_en = this.dataitem.pre_ohter_en;
        }else{
          dataAdd_user.pre_name_en = this.dataitem.prename_en;
        }  
        dataAdd_user.first_name_en = this.dataitem.first_name_en;
        dataAdd_user.last_name_en = this.dataitem.last_name_en;

        dataAdd_user.birth_day = this.dataitem.birth_day;
        dataAdd_user.age = this.dataitem.age;
        dataAdd_user.ethnicity = this.dataitem.ethnicity;
        dataAdd_user.nationality = this.dataitem.nationality;
        dataAdd_user.religion = this.dataitem.religion;
        dataAdd_user.id_card_number = this.dataitem.id_card_number;
        dataAdd_user.phone_number = this.dataitem.phone_number;

        console.log("dataAdd_user: ")
        console.log(dataAdd_user)

        const res_add_user = await api.addTRANNING_USER(dataAdd_user)

        if(res_add_user.status == 200 || res_add_user.status == 201){
          let data_user_d = {
            t_user_id: res_add_user.data.id,
            tranning_id: this.$route.params.tranning_id,
          }
          await api.addTRANNING_USER_D(data_user_d);

          let data_send_m = {
            email: this.email,
            fist_name: this.first_name_en,
            user_name: this.email,
            password: this.dataitem.id_card_number
          }
          await api.sendUserRegister(data_send_m)
          await api.UpdateTranningEmail(this.email_id,{"status": 2});
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            `/login`
          );

        }else{
          this.$hideLoader()
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
          return;
        }
      }else{
          this.$hideLoader()
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
          return;
      }

    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
      },
  },
  async beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = false;

    // this.showdefaultsignature();
  },
  async created() {
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}
.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}
.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  min-height: 10px;
}
.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}
.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}
.widthsize80formadvance {
  width: 80%;
}
.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}
.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}
.btnuploadfile {
  border: 2px solid;
}
</style>
